import { topicTags } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          发现当下最受影迷关注的电影类型与话题标签
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group relative flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer ${
                tag.hot
                  ? 'border-accent-500/30 bg-accent-500/10 hover:bg-accent-500/20'
                  : 'border-background-300/40 bg-background-200/50 hover:border-background-400/60'
              }`}
            >
              {tag.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              )}
              <span className={`text-sm font-medium ${tag.hot ? 'text-accent-400' : 'text-foreground-600'}`}>
                {tag.name}
              </span>
              <span className="text-xs text-foreground-400">{tag.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}